<template >
  <div class="mb-3">
    <div
        class="flex items-center cursor-pointer"
        @click="expand"
    >
      <span class="flex flex-1"><b >{{menu?.title}}</b></span>
      <Icon :name="isExpanded ? 'heroicons:chevron-down-20-solid' : 'heroicons:chevron-up-20-solid'"/>
    </div>
    <nav
        v-if="isExpanded"
        class="ms-4">
      <ul>
        <li
            class="border-s-2"
            v-for="item in menuItems(menu)">
          <NuxtLink
              class="ms-3"
              v-if=!item.subitems
              :to=item.route
              v-bind:class="(isSelected(item)) ? 'current_item' : ''">
            {{item.title}}
          </NuxtLink>
          <UDropdown
              v-if=item.subitems
              v-bind:class="(isSelected(item)) ? 'current_item' : ''"
              :items="item.subitems"
              :popper="{ placement: 'right-start' }">
            <NuxtLink >{{item.title}}</NuxtLink>
          </UDropdown>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup lang="ts">

const {persist} = defineProps({
  menu: Object,
  persist: Boolean
})

const route = useRoute()
const isExpanded = ref(true)

const expand = () => {
  isExpanded.value = !isExpanded.value
}

const isSelected = (item: any):boolean => {
  let res =  route.fullPath.includes(item?.route)

  if (!res && item?.subitems) {
    return item?.subitems.find((el: any)=>{
      return route.fullPath.includes(el[0].to)
    })
  }

  return res
}

const menuItems = (menu: any) => {
  if (persist) return menu?.items
  return menu?.items.sort((a:any,b: any)=>a.title.localeCompare(b.title))
}

</script>

<style scoped>
  .current_item {
    text-decoration: underline;
    color: blue;
  }
</style>
